var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { perkbox, greys } from "@irati/ui/src/global/colors";
import Count from "@irati/ui/src/Count";
import NumberAndText from "../NumberAndText";
import { Flex, StyledCount, DesktopNumberAndText, MobileSignedUpAndRemaining } from "./styled";
var SignedUpAndRemaining = /** @class */ (function (_super) {
    __extends(SignedUpAndRemaining, _super);
    function SignedUpAndRemaining() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SignedUpAndRemaining.prototype.render = function () {
        var _a = this.props, totalLicenses = _a.totalLicenses, numberActivated = _a.numberActivated;
        var remaining = totalLicenses - numberActivated;
        var activatedPercent = Math.round(numberActivated / totalLicenses * 100);
        var remainingPercent = 100 - activatedPercent;
        return (React.createElement(React.Fragment, null,
            React.createElement(Flex, null,
                React.createElement("div", null,
                    React.createElement(DesktopNumberAndText, null,
                        React.createElement(NumberAndText, { number: numberActivated, text: "medical.reports.employees.signedUp" })),
                    React.createElement(Count, { color: perkbox.greenBlue, textColor: greys.white },
                        activatedPercent,
                        "%")),
                React.createElement("div", null,
                    React.createElement(StyledCount, { color: perkbox.greenBlue, textColor: greys.white },
                        remainingPercent,
                        "%"),
                    React.createElement(DesktopNumberAndText, null,
                        React.createElement(NumberAndText, { number: remaining, text: "medical.reports.employees.remaining" })))),
            React.createElement(MobileSignedUpAndRemaining, null,
                React.createElement(NumberAndText, { number: numberActivated, text: "medical.reports.employees.signedUp" }),
                React.createElement(NumberAndText, { number: remaining, text: "medical.reports.employees.remaining" }))));
    };
    return SignedUpAndRemaining;
}(Component));
export default SignedUpAndRemaining;
